export var GraveSearchOption;
(function (GraveSearchOption) {
    GraveSearchOption["Grave"] = "Grave";
})(GraveSearchOption || (GraveSearchOption = {}));
